export default __webpack_public_path__ + "static/media/erasmus.e3ee2bd5.png";